export function validateLimitOrder(data) {
  const { quantityBasisValue, tradePlan } = data;
  if (!quantityBasisValue || quantityBasisValue <= 0)
    return [false, 'Quantity basis value must be larger than zero.'];
  if (tradePlan.goShort && tradePlan.goLong)
    return [false, 'Trade plan cannot be bi-directional and use limit order. '];
  return [true, ''];
}
